// src/services/api.js
import axios from 'axios';
import { auth } from '../firebase'; // Import auth directly

const API_BASE_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_BASE_URL,
});

/**
 * REQUEST INTERCEPTOR
 * Automatically attaches the Firebase ID Token to every request.
 */
api.interceptors.request.use(
  async (config) => {
    try {
      const user = auth.currentUser;
      if (user) {
        // Force refresh only if necessary (Firebase SDK handles caching)
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      } else {
        // Fallback to sessionStorage if auth.currentUser is not yet ready (race condition)
        const token = sessionStorage.getItem('token');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (error) {
      console.error("Error getting ID token:", error);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

/**
 * RESPONSE INTERCEPTOR
 * Handling global errors like 401 or 429.
 */
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response) {
      // Rate Limiting
      if (error.response.status === 429) {
        const rateLimitError = new Error('Rate limit exceeded');
        rateLimitError.status = 429;
        rateLimitError.retryAfter = error.response.data?.retryAfter || 60;
        throw rateLimitError;
      }

      // Auth Error (401)
      if (error.response.status === 401) {
        console.warn("⚠️ 401 Unauthorized detected. Redirecting to login...");
        // Optionally redirect or handle logout
        // window.location.href = '/login'; 
      }
    }
    return Promise.reject(error);
  }
);

export default api;